import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './SignIn.css';

function ResetPassword() {
    const location = useLocation();
    const navigate = useNavigate();
    const phone = location.state?.phone || "";

    const [code, setCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleReset = async (e) => {
        e.preventDefault();

        if (!code || !newPassword) {
            setErrorMessage("Bütün xanaları doldurun!");
            return toast.warn("⚠️ Bütün xanaları doldurun!");
        }

        if (newPassword.length < 8) {
            setErrorMessage("Şifrə minimum 8 simvol olmalıdır!");
            return toast.error("❌ Şifrə minimum 8 simvol olmalıdır!");
        }

        setLoading(true);
        setErrorMessage("");

        try {
            await axios.post("https://api.herracim.az/api/Account/reset-password", {
                emailOrPhone: phone,
                code,
                newPassword
            });

            toast.success("🎉 Şifrə uğurla dəyişdirildi!");
            setTimeout(() => {
                navigate("/giris", {
                    state: {
                        message: "Şifrəniz yeniləndi! İndi yeni şifrə ilə giriş edə bilərsiniz."
                    }
                });
            }, 2000);
        } catch (err) {
            console.error("🚨 Xəta:", err);
            const errorMsg = err.response?.data || "Kod yanlışdır və ya vaxtı keçib";
            setErrorMessage(errorMsg);
            toast.error(`❌ ${errorMsg}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='herrac-reset-wrapper'>
            <div className='herrac-reset-overlay'></div>

            <div className="herrac-reset-container">
                <Link to="/giris" className='herrac-reset-close' aria-label='Bağla'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </Link>

                <div className="herrac-reset-card">
                    <div className='herrac-reset-header'>
                        <div className='herrac-reset-icon'>
                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                <circle cx="24" cy="24" r="22" stroke="url(#gradient6)" strokeWidth="2"/>
                                <path d="M24 12V24L30 27" stroke="url(#gradient6)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M34 14C36.2091 14 38 15.7909 38 18V22" stroke="url(#gradient6)" strokeWidth="2" strokeLinecap="round"/>
                                <defs>
                                    <linearGradient id="gradient6" x1="0" y1="0" x2="48" y2="48">
                                        <stop offset="0%" stopColor="#30cfd0"/>
                                        <stop offset="100%" stopColor="#330867"/>
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <h2 className='herrac-reset-title'>Yeni Şifrə Təyin Et</h2>
                        <p className='herrac-reset-subtitle'>SMS ilə göndərilən kodu daxil edin</p>
                    </div>

                    {phone && (
                        <div className="herrac-reset-phone-display">
                            📱 {phone}
                        </div>
                    )}

                    <form className="herrac-reset-form" onSubmit={handleReset}>
                        <div className='herrac-reset-input-group'>
                            <label className='herrac-reset-label'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.8333 3.75H4.16667C3.24619 3.75 2.5 4.49619 2.5 5.41667V14.5833C2.5 15.5038 3.24619 16.25 4.16667 16.25H15.8333C16.7538 16.25 17.5 15.5038 17.5 14.5833V5.41667C17.5 4.49619 16.7538 3.75 15.8333 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M6.66667 7.5V12.5M10 7.5V12.5M13.3333 7.5V12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Təsdiq kodu
                            </label>
                            <input
                                type="text"
                                placeholder="000000"
                                value={code}
                                onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
                                className='herrac-reset-input'
                                required
                                disabled={loading}
                                maxLength={6}
                            />
                        </div>

                        <div className='herrac-reset-input-group'>
                            <label className='herrac-reset-label'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.8333 9.16667H4.16667C3.24619 9.16667 2.5 9.91286 2.5 10.8333V16.6667C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6667V10.8333C17.5 9.91286 16.7538 9.16667 15.8333 9.16667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M5.83333 9.16667V5.83333C5.83333 4.72826 6.27232 3.66846 7.05372 2.88706C7.83512 2.10565 8.89493 1.66667 10 1.66667C11.1051 1.66667 12.1649 2.10565 12.9463 2.88706C13.7277 3.66846 14.1667 4.72826 14.1667 5.83333V9.16667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Yeni şifrə
                            </label>
                            <div className='herrac-reset-password-wrapper'>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Minimum 8 simvol"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    className='herrac-reset-input'
                                    required
                                    disabled={loading}
                                />
                                <button
                                    type='button'
                                    className='herrac-reset-password-toggle'
                                    onClick={() => setShowPassword(!showPassword)}
                                    disabled={loading}
                                >
                                    {showPassword ? (
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M2.5 10C2.5 10 5 4.16667 10 4.16667C15 4.16667 17.5 10 17.5 10C17.5 10 15 15.8333 10 15.8333C5 15.8333 2.5 10 2.5 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    ) : (
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M8.33333 8.33333C8.11232 8.65885 7.99609 9.04836 8.00008 9.44605C8.00407 9.84373 8.12806 10.2306 8.35531 10.5515C8.58256 10.8723 8.90151 11.1116 9.2695 11.2372C9.63749 11.3627 10.0346 11.3683 10.4058 11.2533M11.6667 11.6667C11.0844 12.0992 10.3609 12.2822 9.64002 12.178C8.91916 12.0739 8.26431 11.6903 7.80834 11.1066C7.35237 10.5229 7.13046 9.78413 7.19185 9.04086C7.25325 8.29759 7.59299 7.60648 8.14167 7.1M14.95 14.95C13.5255 16.0358 11.788 16.6374 10 16.6667C5 16.6667 2.5 10 2.5 10C3.45651 8.06825 4.81629 6.38051 6.475 5.05L14.95 14.95ZM8.25833 3.53333C8.82361 3.39907 9.4009 3.33195 9.98 3.33333C14.98 3.33333 17.4808 10 17.4808 10C17.0535 10.9463 16.5269 11.8423 15.9108 12.6742L8.25833 3.53333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M2.5 2.5L17.5 17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>

                        {errorMessage && (
                            <div className='herrac-reset-error' role='alert'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10 6.66667V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10 13.3333H10.0083" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                {errorMessage}
                            </div>
                        )}

                        <button 
                            type="submit"
                            className='herrac-reset-button'
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className='herrac-reset-spinner'></span>
                                    Dəyişdirilir...
                                </>
                            ) : (
                                <>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M16.6667 5L7.5 14.1667L3.33333 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Şifrəni dəyiş
                                </>
                            )}
                        </button>
                    </form>

                    <div className='herrac-reset-footer'>
                        <span 
                            onClick={() => navigate(-1)} 
                            className='herrac-reset-footer-link'
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Geri qayıt
                        </span>
                        <Link to="/giris" className='herrac-reset-footer-link'>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 2V8L11 11" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                                <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.2"/>
                            </svg>
                            Giriş səhifəsinə qayıt
                        </Link>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                theme="light"
                style={{ zIndex: 99999 }}
            />
        </div>
    );
}

export default ResetPassword;